const zh = {
  title: '支付链',
  create: '创建支付链',
  paymentLinkId: '支付链ID',
  paymentLink_Id: '支付链-ID',
  bookingName: '预订人姓名',
  bookingNameEmail: '预订人姓名/邮箱',
  orderNo: '业务订单号',
  amount: '金额',
  tradingamount: '交易金额',
  minAmount: '最小值',
  maxAmount: '最大值',
  createTime: '创建时间',
  paymentLinkStatus: '支付链状态',
  status: '支付状态',
  operate: '操作',
  search: '查询',
  reset: '重置',
  add: '新增',
  edit: '编辑',
  delete: '删除',
  export: '导出',
  detail: '详情',
  resend: '再次发送',
  disable: '置为失效',
  tipsTitle: '提示',
  invalidTip: '该支付链已经置为失效状态',
  setInvalid: '是否确定将此条支付链置为失效， 失效后将无法在恢复生效',
  sendSuccess: '发送成功',
  deleteSuccess: '删除成功',
  notTepmTitle: '您尚未创建账单模版',
  notTepmTip: '请在【模版管理】功能中创建账单模版后，再创建支付链',
  toNewVersion: '返回新版本页面',
  toOldVersion: '返回老版本页面',
  createLink: {
    title: '创建新的支付链',
    otherFee: '是否有其它费用？',
    yes: '是',
    no: '否',
    otherFeeName: '其它费用名称',
    createSuccess: '支付链创建成功！',
    tip: '创建信息中未填写付款人E-mail，将单独生成支付链链接'
  },
  brandList: {
    title: '品牌信息维护',
    brandName: '品牌名称',
    website: '网站',
    updateTime: '更新时间',
    add: '新增品牌',
    logo: 'Logo',
    preview: '预览',
    brandWeb: '品牌网站',
    contact: '联系方式',
    validTime: '支付链有效时间',
    email: '邮件通知模版',
    edit: '编辑',
    delete: '删除',
    deleteTip: '是否确定删除此条品牌信息'
  },
  paymentLinkDetail: {
    setInvalid: '置为失效',
    resend: '重新发送',
    validTime: '有效时间',
    hours: '小时',
    remaining: '剩余',
    linkAddress: '支付链链接地址',
    userInfo: '客户信息',
    name: '姓名',
    phone: '手机号',
    email: 'E-mail',
    en: '英语',
    lang: '收银台语种',
    country: '付款人所在国家/地区',
    remarks: '备注',
    orderInfo: '账单信息',
    productInfo: '商品信息',
    editProductInfo: '修改商品信息',
    affiliatedWebsite: '所属网站',
    currency: '账单币种',
    serviceDate: '服务日期',
    city: '城市',
    total: '总计',
    totalAmount: '总金额',
    brandInfo: '品牌信息',
    brandName: '品牌名称',
    addProduct: '添加',
    addProductTip: '请',
    createPayLinkValidate: '您还未添加商品信息，无法创建支付链哦～',
    previewPayLinkValidate: '您还未添加商品信息，无法预览账单哦～',
    cancelTip: '基础信息尚未填写完整，无法生成支付链，是否确认取消？',
    // 支付链标准化
    template: '账单模版',
    website: '关联网站',
    prodName: '商品名称',
    prodDesc: '商品描述',
    PassengerName: '乘客名字',
    hotelName: '酒店名字',
    days: '房间天数',
    roomsNumber: '房间数量',
    price: '单价',
    count: '数量',
    amount: '金额',
    rentType: '租赁类型',
    address: '地址',
    apartmentNumber: '房源号',
    rentTime: '租期',
    carModel: '租用车型',
    destinationAddress: '目的地地址',
    mileage: '里程',
    carRentalUnitPrice: '租车单价',
    carRentCountry: '提车城市',
    carTime: '服务日期',
    travelCity: '旅游城市',
    takeOffCity: '出发城市',
    travelCountry: '旅游国家',
    travelTime: '行程周期',
    flightNumber: '航班号',
    aircraftCabinType: '舱等',
    takeOffTime: '航班起⻜时间',
    arrivalTime: '航班抵达时间',
    reChargeType: '充值类型',
    accountId: '充值账户ID',
    accountName: '充值账户姓名',
    appName: 'Game/APP名称'
  },
  brandListDetail: {
    breadcrumbTitle: '品牌信息维护',
    breadcrumbAddTitle: '添加品牌',
    addTitle: '添加品牌信息',
    editTitle: '修改品牌信息',
    brandName: '品牌名称',
    brandWebsite: '品牌网址',
    emailTopics: '邮件主题',
    contact: '联系方式',
    sender: '发件人',
    logo: 'Logo',
    emailTemp: '邮件模版',
    dynamicData: '动态数据',
    validTime: '支付有效时间',
    hours: '小时',
    tips: '不超过168小时',
    editButton: '修改',
    addButton: '添加',
    cancelButton: '取消',
    confirmButton: '确认',
    emailTempTip: '点击此处开始输入邮件模版...',
  },
  emailPreview: {
    title: '品牌信息维护',
    preview: '预览'
  },
  payLinkRules: {
    template: '请选择账单模版',
    accId: '请选择所属网站',
    currency: '请选择币种',
    brandId: '请选择品牌名称',
    name: '请填写预订人姓名',
    phone: '请填写手机号',
    email: '请填写E-mail',
    country: '请选择国家/地区',
    otherFeeName: '请填写其它费用名称',
    otherFeeAmount: '请填写金额',
    required: '该字段为必填项',
  },
  brandRules: {
    brandName: '请填写品牌名称',
    website: '请填写品牌网址',
    subject: '请填写邮件主题',
    contact: '请填写联系方式',
    logo: '请上传Logo',
    emailTemplate: '请填写邮件模版',
    validHours: '请填写支付有效时间',
    validHours168: '支付有效时间不能超过168小时',
    emailSender: '请选择发件人',
  },
  // 春秋航空定制
  springAirlines: {
    message: {
      title: '办理行李托运',
      userInfo: '个人信息',
      billingInfo: '订单地址',
      orderInfo: '订单详情',
      name: '姓名',
      phone: '手机',
      email: '邮箱',
      country: '国家/地区',
      city: '城市',
      zipCode: '邮编',
      state: '省份',
      street: '详细地址',
      goodsName: '产品名称',
      baggageFee: '行李托运费',
      amount: '金额',
      submit: '提交并支付',
    },
    rules: {
      name: '请填写姓名',
      phone: '请填写手机',
      amount: '请填写金额',
    }
  },
  // 模版管理
  templateManage: {
    title: '模板管理',
    sector: '所属行业',
    templateName: '模板名称',
    addTemplate: '添加新的模板',
    updateTime: '更新时间',
    defaultTemplate: '系统',
    deleteTip: '是否确认删除模版信息',
    deleteSuccess: '删除成功'
  },
  templateDetail: {
    editTitle: '修改模版',
    addTitle: '添加新的模版',
    detailTitle: '系统模版详情',
    tip: '账单发送时系统固定字段语言为英文，自定义字段名称请尽量使用英文',
    customerData: '客户信息',
    productData: '商品信息',
    addField: '添加字段',
    options: '选项',
    editOptions: '编辑选项',
    addOptions: '添加选项',
    addOptionsTip: '只允许您的客户选择一个选项',
    editButton: '修改',
    addButton: '创建',
    cancelButton: '取消',
  },
  templateFields: {
    fieldName: '字段名称',
    labelName: '标签名称',
    fieldType: '类型',
    fieldRule: '必填/选填',
    fieldRequired: '必填',
    fieldOptional: '选填',
    fieldText: '文本',
    fieldNumber: '数字',
    fieldSelect: '下拉',
    fieldDate: '日期',
    fieldPercent: '百分比',
  },
  templateRules: {
    sector: '请选择所属行业',
    templateName: '请填写模版名称',
    fieldName: '请填写字段名称',
    fieldType: '请选择字段类型',
    fieldRule: '请选择字段校验规则',
    optionsRule: '请新增自定义选项',
    optionsValid: '请先输入您新增的选项再保存',
  },
  map: {
    longTerm: '长租',
    shortTerm: '短租',
    firstClass: '头等舱',
    businessClass: '商务舱',
    premiumEconomy: '高端经济舱',
    economy: '普通经济舱',
    small: '小型车',
    medium: '中型车',
    large: '大型车',
    premium: '豪车',
    suvTruck: '卡车',
    van: '货箱车',
    convertible: '敞篷车',
  },
  industryMap: {
    apartmentRent: '房屋租赁',
    eCommerce: '电商',
    carRental: '租车',
    airline: '航司',
    tourism: '旅游',
    rentalInfo: '租赁信息',
    productInfo: '商品信息',
    flightInfo: '航班信息',
    serviceInfo: '服务信息',
    reCharge: '充值',
    reChargeInfo: '充值信息',
    hotel: '酒店',
    hotelInfo: '酒店信息'
  },

  // 支付链优化 - 3
  payLink: {
    orderPreview: '账单预览',
    preview: '预览',
    saveDraft: '保存草稿',
    send: '提交',
    selectWeb: '选择网站',
    orderNo: '业务订单号',
    theme: '主题',
    modeName: '模式名称',
    payerInfo: '付款人信息',
    name: '姓名',
    phone: '手机号',
    remark: '备注',
    notThemeTitle: '您尚未创建主题',
    notThemeTip: '请在【主题管理】功能中创建主题后，再创建支付链',
    notThemeButton: '前往创建主题',
    notModeTitle: '您尚未创建模式',
    notModeTip: '请在【模式管理】功能中创建模式后，再创建支付链',
    notModeButton: '前往创建模式',
  },
  modeManage: {
    title: '模式设置',
    addMode: '新增模式',
    modeName: '模式名称',
    isSendEmail: '发送邮件',
    effectiveTime: '有效时长',
    updateTime: '更新时间',
    deleteTip: '是否确认删除模式信息',
    deleteSuccess: '删除成功'
  },
  addMode: {
    title: '模式管理',
    addMode: '新增模式',
    editMode: '编辑模式',
    emailInfo: '邮件信息',
    isNeedEmail: '是否需要邮件服务 ',
    yes: '是',
    no: '否',
    tip: '我们将在您发送支付链接的时候，同时发送邮件至账单所填写的顾客邮箱。',
    insert: '插入动态数据',
    clientName: '客户名称',
    orderInfo: '账单详情',
    checkAmount: '账单金额',
    checkId: '账单编号',
    expireTime: '到期时间',
    paymentLink: '支付链接',
    emailTitle: '邮件标题',
    emailContent: '邮件内容',
    sender: '发件人',
    linkExpire: '链接有效期',
    oneDay: '24小时',
    twoDays: '48小时',
    custom: '自定义',
    create: '创建',
    edit: '修改',
    previewEmail: '预览邮件',
    cancel: '取消',
    required: '该选项为必填项',
    validHours168: '支付有效时间不能超过168小时',
    hours: '小时',
    hoursTips: '不超过168小时',
    previewTip: '请先填入邮件内容'
  },
  theme: {
    manage: '主题管理',
    title: '主题信息',
    editTheme: '编辑主题',
    copyTheme: '复制主题',
    addTheme: '新增主题',
    deleteTheme: '删除主题',
    themeName: '主题名称',
    brandName: '品牌名称',
    brandLogo: '品牌logo',
    preview: '预览',
    fields: '账单字段信息',
    sector: '行业类别',
    ifSetDefault: '是否设为默认主题？',
    setDefault: '设置为默认主题',
    yes: '是',
    no: '否',
    create: '创建',
    edit: '修改',
    cancel: '取消',
    // 主题列表
    default: '默认',
    updateOf: '更新于',
    deleteTip: '是否确认删除？',
    emptyTip: '暂无数据，请添加主题'
  },
  totalFee: {
    amount: '小计',
    totalAmount: '总计',
  }
}

export default zh
